import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  btnContainer: {
    '& .tab': {
      '&-content': {
        display: 'flex',
        alignItems: 'center',
      },
      '&-text': {
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&-ammount': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        height: '20px',
        border: 'solid 1px',
        borderColor: props =>
          fade(
            props.active === props.index
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
            0.26,
          ),
        borderRadius: '50%',
        marginLeft: theme.spacing(1),
      },
    },
  },
}));

export default styles;
